module.exports = __webpack_public_path__ + "assets/img/elem2-ability2.b79517e9.gif";